import C from '../../../constants';
import rStore from '../../../store';

import {browserHistory} from 'react-router';

import PolyUtil from "../../../util/PolyUtil";
import {incFlowKey} from "../../../store/actions/display";
import {SubmissionError} from "redux-form";

export const setGuarantor = (guarantor) => ({
    type: C.SET_GUARANTOR,
    payload: guarantor
});

export const setGuarantorVerified = (verified) => ({
    type: C.SET_GUARANTOR_VERIFIED,
    payload: verified
});

export const fetchGuarantorIdmaStatus = (tenantId, key) => dispatch => {
    if (rStore.getState().guarantor.confirmed) {
        return PolyUtil.fetchWrapper('/api/credit/idma/check-status/guarantor/' + tenantId + '/' + key + '/',
            {method: 'GET'}
        ).then((data) => {
            return dispatch(setGuarantorVerified(data.verification_status));
        }).catch((error) => {
            console.log("Error:", error);
        });
    }
};

export const fetchGuarantor = (tenantId, key) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/guarantor/' + tenantId + '/' + key + '/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setGuarantor(data));
    }).then(() => {
        return dispatch(fetchGuarantorIdmaStatus(tenantId, key));
    }).catch((error) => {
        console.log("Error: ", error);

        if (error.error_code === 'invalid_key') {
            browserHistory.push('/invalid_link');
        }
    });
};

export const handleSubmitGuarantorConfirm = (data, tenant_id, key) => dispatch => {
    const form = Object.assign({}, data, {
        address_place_id: data.place_id,
        phone: '+1' + data.phone.replace(new RegExp('-', 'g'), ''),
    });

    delete form.place_id;
    delete form.checkconfirm;
    delete form.formatted_address;

    return PolyUtil.fetchWrapper('/api/tenant/application/guarantor/' + tenant_id + '/' + key + '/',
        {
            method: 'PUT',
            body: JSON.stringify(form)
        }
    ).then(() => {
        return PolyUtil.fetchWrapper('/api/tenant/application/guarantor/' + tenant_id + '/' + key + '/confirm/',
            {method: 'POST'}
        );
    }).then(() => {
        return dispatch(fetchGuarantor(tenant_id, key));
    }).then(() => {
        return dispatch(incFlowKey('guarantorFlow'));
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};



// WEBPACK FOOTER //
// ./src/containers/guarantor/actions/guarantor.js